import { loggerBase } from './loggerBase';

const envLogLevel = process.env.GATSBY_LOG_LEVEL?.toLowerCase();
export const logger = loggerBase(envLogLevel);
